import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { put, takeLeading } from "redux-saga/effects";
import { Urls } from "src/constants";
import { HttpService, _ } from "src/services";
import { ModalsAction, PackagesAction, UserSessionAction } from "../actions";
import { ReduxAction } from "../models";
import { UserSessionTypes } from "../types/user.session.types";
import FingerprintJS, { Agent, GetResult } from "@fingerprintjs/fingerprintjs";
import { ProfilePromotionLinks } from "src/models";

export function* UserSessionSaga() {
  yield takeLeading(UserSessionTypes.REQUEST_LOGIN_CODE, requestCode);
  yield takeLeading(UserSessionTypes.VERIFY_LOGIN_CODE, verifyCode);
  yield takeLeading(UserSessionTypes.REQUEST_USER_INFO, requestInfo);
  yield takeLeading(UserSessionTypes.UPDATE_PROFILE, updateProfile);
  yield takeLeading(
    UserSessionTypes.REMIND_PROFILE_COMPLETE_LATER,
    remindMeLater
  );
}

function* remindMeLater(action: ReduxAction) {
  const link: ProfilePromotionLinks = action.payload;
  try {
    yield HttpService.Fetch(Urls.packApi(null, link.href, link.method, false));
    yield put(UserSessionAction.hideLoading());
  } catch {
    yield put(UserSessionAction.hideLoading());
  }
}

function* updateProfile(action: ReduxAction) {
  try {
    const api = Urls.profile.update();

    const response: AxiosResponse = yield HttpService.Fetch(
      api,
      action.payload
    );

    if (response.data) {
      yield put(UserSessionAction.setUser(response.data));
      yield put(UserSessionAction.hideLoading());
      yield put(ModalsAction.hideProfile());
      toast.success(_("profileUpdated"));
      if (response.data.updateNotify) {
        yield put(ModalsAction.showProfileCompletedMessage());
      }
    }
  } catch {
    yield put(UserSessionAction.hideLoading());
  }
}

function* requestCode(action: ReduxAction) {
  try {
    const phone = action.payload;
    const api = Urls.auth.login();

    const response: AxiosResponse = yield HttpService.Fetch(api, { phone });

    if (response.data) {
      yield put(UserSessionAction.login(response.data));
    }
  } catch {
    yield put(UserSessionAction.hideLoading());
  }
}

function* verifyCode(action: ReduxAction) {
  try {
    const { id, code, phone } = action.payload;
    const api = Urls.auth.verify(id);

    const fpPromise = FingerprintJS.load();
    const fp: Agent = yield fpPromise;
    const result: GetResult = yield fp.get();
    const visitorId = result.visitorId;

    const visitorIdHalf = Math.floor(visitorId.length / 2);
    const phoneHalf = Math.floor(phone.length / 2);

    const deviceInfo = {
      manufacturer: "Desktop",
      platform: 4,
      screenWidth: window.outerWidth,
      screenHeight: window.outerHeight,
      udid: `${visitorId.substring(0, visitorIdHalf)}${phone.substring(
        phoneHalf
      )}${visitorId.substring(visitorIdHalf)}${phone.substring(0, phoneHalf)}`,
    };

    const response: AxiosResponse = yield HttpService.Fetch(api, {
      code,
      phone,
      deviceInfo,
    });

    if (response.data) {
      yield put(UserSessionAction.login(response.data));
      yield put(PackagesAction.clear());
    }
  } catch {
    yield put(UserSessionAction.hideLoading());
  }
}

function* requestInfo(action: ReduxAction) {
  try {
    const api = Urls.profile.info();
    const response: AxiosResponse = yield HttpService.Fetch(api);

    if (response.data) {
      yield put(UserSessionAction.setUser(response.data));
    }
  } catch {
    yield put(UserSessionAction.setUser(undefined));
  }
}
